export default "__VITE_ASSET__CNtc_yVB__"